import { render, staticRenderFns } from "./confirm-data.vue?vue&type=template&id=2fadac3e&scoped=true"
import script from "./confirm-data.vue?vue&type=script&lang=js"
export * from "./confirm-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fadac3e",
  null
  
)

export default component.exports